<template>
  <b-modal
      v-model="isModalOpen"
      title=""
      centered
      size="md"
      hide-footer
      no-close-on-backdrop
      content-class="content-class"
      header-class="header-class"
      @hidden="handleCancel"
  >
    <b-row>
      <b-col cols="12" md="6">
        <div class="d-none d-md-block banner-image">
          <img src="@/module_user/assets/images/landingPage/girl-workout.jpg" alt="Image"/>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="p-4">
        <b-row>
          <b-col cols="12">
            <div class="d-flex flex-column">
              <h3>Upgrade to EliteFit Premium</h3>
              <b-icon icon="cross" @click="handleCancel"></b-icon>
              <p class='header-title text-muted mb-4'>Unlock all workouts and personalized plans.</p>
            </div>
          </b-col>
          <b-col cols="12" v-if="selectedTabPlans.length">
            <b-row>
              <b-col cols="12">
                <b-row class="mb-2">
                  <b-col md="6" class="flex-nowrap d-flex align-items-center"><h4 class="choose-plan-heading">Choose Your Plan</h4></b-col>
                  <b-col md="6" class="d-flex justify-content-center justify-content-sm-start">
                    <div class="pricing-tabs" v-if="tabs.length > 1">
                      <div v-for="tab of tabs"
                           @click="selectTab(tab)"
                           class="pricing-tab text-capitalize"
                           :class="{'selected': selectedTab === tab}">{{ tab }}</div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2 row-col-gap">
                  <div class="pricing-cards">
                    <div class="pricing-card cursor-pointer"
                         v-for="plan of selectedTabPlans"
                         :class="{'selected-plan': selectedPlan && plan.id === selectedPlan.id}"
                         @click="selectedPlan = plan">
                      <div class="background"
                           :style="{background: plan.background}"></div>
                      <div class="content">
                        <div class="plan-name">{{plan.name}}</div>
                        <div class="plan-price">{{`${plan.country.currencySymbol}${plan.amount}/${plan.validityType === 'yearly'?'year':'month'}`}}</div>
                      </div>
                    </div>
                  </div>
                </b-row>
                <b-row class="mb-2">
                  <b-col cols="12">
                    <button :disabled="!selectedPlan" class="btn update-btn my-3" @click="upgradePlan(selectedPlan)">
                      <b-icon icon="arrow-up"></b-icon> Upgrade Account
                    </button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" v-if="selectedPlan">
            <div class="d-flex flex-column benefits-container">
              <div class="font-weight-500 mb-2">Premium Benefits:</div>
              <div class="text-gray d-flex" v-for="feature of selectedPlan.features">
                <b-icon icon="check2-circle" class="feature-tick"></b-icon>
                <div>{{ feature }}</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <loader v-if="loading"></loader>
    </b-row>
  </b-modal>
</template>

<script>
import CodeInput from "vue-verification-code-input";
import b2bService from "@/module_user/api/b2b-service";

export default {
  components: {CodeInput},
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    onCancelReturn: {type: Boolean, default: false}
  },
  data() {
    return {
      accessCode: '',
      accessCodeError: '',
      promoCode: '',
      promoCodeError: '',
      isModalOpen: this.isOpen,
      pushToRoute: {
        name: "Main"
      },
      selectedTab: 'monthly',
      loading: false,
      plans: [],
      tabs: [],
      selectedPlan: null,
    }
  },
  watch: {
    isOpen(newVal) {
      this.isModalOpen = newVal;
    }
  },
  computed: {
    selectedTabPlans() {
      return this.plans.filter(plan => plan.validityType === this.selectedTab);
    },
    isCorporate() {
      return !!this.$store.state.userInfo?.corporate;
    },
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
      this.selectedPlan = this.selectedTabPlans.length ? this.selectedTabPlans[0]: null;
    },
    getColorGradient() {
      return `white`
    },
    handleCancel() {
      this.$emit('onCancel');
      if (this.onCancelReturn) this.$router.push(this.pushToRoute);
    },
    getPlans() {
      if (this.isCorporate) {
        return b2bService.corporateSubscriptionPlans()
            .then(plans => plans.map(plan => Object.assign({background: this.getColorGradient()}, plan)));
      } else {
        return b2bService.endUserSubscriptionPlans("Fitness Program")
            .then(plans => plans.map(plan => Object.assign({background: this.getColorGradient()}, plan)));
      }
    },
    upgradePlan(plan) {
      const {id, country} = plan;
      this.loading = true;
      if (this.isCorporate) {
        b2bService.createAdminCheckoutSession({
          subscriptionId: id, countryIso: country.iso
        }).then(data => {
          window.location.href = data.url;
        }).catch(error => {
          this.$swal({
            icon: 'error',
            title: 'Payment Processing Failed',
            text: 'Sorry, your payment could not be processed. Please try again later.',
            confirmButtonColor: '#73bc44',
            confirmButtonText: 'OK'
          });
        }).finally(_ => this.loading = false);
      } else {
        b2bService.createEndUserCheckoutSession({
          planId: id, countryIso: country.iso
        }).then(data => {
          window.location.href = data.url;
        }).catch(error => {
          this.$swal({
            icon: 'error',
            title: 'Payment Processing Failed',
            text: 'Sorry, your payment could not be processed. Please try again later.',
            confirmButtonColor: '#73bc44',
            confirmButtonText: 'OK'
          });
        }).finally(_ => this.loading = false);
      }
    }
  },
  async mounted() {
    this.loading = true;
    this.plans = await this.getPlans();
    this.plans.forEach(plan => {
      if (Boolean(plan.validityType) && !this.tabs.includes(plan.validityType)) this.tabs.push(plan.validityType);
    });
    if (this.tabs.length) this.selectTab(this.tabs[0]);
    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
::v-deep .content-class {
  border-radius: 12px;
  width: auto;
  margin: auto;
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-width: 900px;

  .or-position {
    top: 50%;
    transform: translate(0px, -50%);
  }
  .col-form-label {
    font-weight: 500;
  }

  .row-col-gap {
    gap: 16px;
  }
  .choose-plan-heading {
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 600;
  }
  .pricing-tabs {
    display: flex;
    border-radius: 22px;
    border: 4px solid #d7d7d7;
    background-color: #d7d7d7;
    max-height: 36px;

    .pricing-tab {
      border-radius: 22px;
      background-color: transparent;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: .3px;
      height: auto;
      line-height: 20px;
      padding: 2px 8px;
      transition: color .15s ease-in, font-weight .15s ease-in;
      cursor: pointer;
      display: flex;
      position: relative;
      text-align: left;
      align-items: center;
    }
    .pricing-tab.selected {
      background-color: #73bc45;
      color: white;
      font-weight: 500;
    }
  }
  .pricing-cards {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    padding-right: 15px;
    padding-left: 15px;
    row-gap: 8px;
    column-gap: 8px;
  }
  .pricing-card {
    flex-grow: 1;
    overflow: hidden;
    padding: 16px;
    display: flex;
    flex-direction: column;
    min-width: 100px;
    //max-width: fit-content;
    position: relative;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;

    .background {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: .25;
    }

    .plan-name {
      font-weight: 600;
      padding-bottom: 8px;
    }
    .plan-price {
      font-weight: 500;
      line-height: 1;
    }
  }
  .collapse-container {
    margin-bottom: 1rem;

    .invalid-feedback {
      display: flex !important;
      justify-content: center;
      padding-top: 8px;
    }
  }
  .benefits-container {
    color: rgb(75, 85, 99);
  }
  .code-input-container {
    font-weight: 500;
  }
  .break-line {
    border-bottom: solid 1px hsla(240 5.9% 90%);
  }
  .redeem-apply-button {
    font-size: inherit;
    padding: .5rem .75rem;
    color: white;
    font-weight: 500;
    line-height: inherit;
  }
  .feature-tick {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
    color: #73bc45;
  }
  .code-input {
    margin-right: 16px;
    display: flex;
    align-items: center;
    width: auto !important;

    .react-code-input {
      display: flex;
      justify-content: center;
      gap: 8px;
    }
    input {
      font-size: 22px !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  .selected-plan {
    border: solid 2px green;
  }
  .banner-image {

    img {
      object-fit: cover;
      width: 100%;
      height: auto;
    }
  }
}
::v-deep .header-class {
  border-bottom: none;
  padding-bottom: 0;
}
.btn {
  font-size: 1rem;
  line-height: 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  background-color: #73bc45;
  width: 100%;
  color: white !important;
}
.btn:disabled {
  background-color: grey;
  border-color: grey;
}
.btn:focus,
.btn:active,
.btn:hover {
  outline: none !important;
  text-decoration: none;
}
</style>